import React from "react";
import Layout from "../components/Layout";

import ScrollingText from "../components/lettersslider";
import ServiceComponent from "../components/servicedescrpition";
import ComponentWithCards from "../components/serviceheadings";
import OurService from "../components/servicepage/ourservice";
import ContactForm from "../components/servicecontact";

import CoursesHeader from "../components/coursesheader";
import CoursesServices from "../components/coursesservices";
import useScrollTransition from "../useScrollTransition";

const CoursesPage = () => {
  useScrollTransition();
  return (
    <Layout>
      <CoursesHeader />
      <ScrollingText />
      <CoursesServices />
      <ServiceComponent />
      <ComponentWithCards />
      <OurService />
      <ContactForm />
    </Layout>
  );
};

export default CoursesPage;
